import React from 'react';

import documentIcon from 'assets/icons/document.svg';

import './styles.css';

const DocumentWithFilename = ({filename}) => (
  <div className="DocumentWithFilename colab-row-space-between">
    <div className="DocumentWithFilename__preview colab-centered">
      <img src={documentIcon} />
    </div>

    <div className="DocumentWithFilename__filenameContainer colab-sidepadding-1 colab-centered-v">
      <div className="DocumentWithFilename__filenameContainer--filename colab-bold">
        {filename}
      </div>
    </div>
  </div>
);

export default DocumentWithFilename;
